import React from "react";
import PropTypes from "prop-types";

const DataGrid = ({
  xLabels,
  yLabels,
  data,
  background,
  height,
  yLabelTextAlign,
  unit,
  displayYLabels,
  onClick,
  cursor,
  squares,
  cellStyle,
  title,
  yLabelWidth,
}) => {
  const flatArray = data.reduce((i, o) => [...o, ...i], []);
  const max = Math.max(...flatArray);
  const min = Math.min(...flatArray);

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        marginTop: "5px",
      }}
    >
      {yLabels.map((y, yi) => (
        <div key={yi} style={{ display: "flex", flex: 1 }}>
          <div
            style={{
              textAlign: yLabelTextAlign,
              flex: 1,
              display: "flex",
              color: "#98A2BC",
            }}
          >
            <div
              style={{
                width: yLabelWidth,
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                fontSize: "0.75rem",
                lineHeight: "0.75rem",
                fontFamily: "inherit",
              }}
            >
              {displayYLabels && y}
            </div>
            {xLabels.map((x, xi) => {
              const value = data[yi][xi];
              const style = Object.assign(
                {
                  cursor: `${cursor}`,
                  margin: "1px 1px 0 0",
                  height: "calc(100%-1px)",
                  flex: squares ? "none" : 1,
                  textAlign: "center",
                },
                cellStyle(background, value, min, max, data, xi, yi)
              );
              return (
                <div
                  onClick={onClick.bind(this, xi, yi)}
                  title={title(value, unit, xi, yi)}
                  key={`${xi}_${yi}`}
                  style={style}
                >
                  {/* <div style={{ paddingTop: `${height / 3.7}px` }}>
                    {cellRender(value, x, y)}
                  </div> */}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

DataGrid.propTypes = {
  xLabels: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ).isRequired,
  yLabels: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.array).isRequired,
  background: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  xLabelWidth: PropTypes.number.isRequired,
  yLabelWidth: PropTypes.number.isRequired,
  yLabelTextAlign: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  displayYLabels: PropTypes.bool,
  onClick: PropTypes.func,
  cursor: PropTypes.string,
  squares: PropTypes.bool,
  cellRender: PropTypes.func.isRequired,
  cellStyle: PropTypes.func.isRequired,
  title: PropTypes.func,
};

DataGrid.defaultProps = {
  yLabelWidth: "50px",
  displayYLabels: true,
  cursor: "",
  onClick: () => {},
  squares: false,
  title: (value, unit) => (value || value === 0) && `${value} ${unit}`,
};

export default DataGrid;
